/* =========================================================
   GHARART LUXURY EDITORIAL SYSTEM
   INTERACTIONS + REVEALS
========================================================= */

document.addEventListener('DOMContentLoaded', () => {

  /* =======================================================
     REVEAL ANIMATIONS
  ======================================================= */

  const revealElements = document.querySelectorAll('.ga-reveal');

  if ('IntersectionObserver' in window) {

    const observer = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }

      });

    }, {
      threshold: 0.15
    });

    revealElements.forEach((element) => {
      observer.observe(element);
    });

  } else {

    revealElements.forEach((element) => {
      element.classList.add('is-visible');
    });

  }

  /* =======================================================
     PARALLAX
  ======================================================= */

  const parallaxImages = document.querySelectorAll('.ga-parallax');

  if (window.innerWidth > 989) {

    window.addEventListener('scroll', () => {

      const scrollTop = window.pageYOffset;

      parallaxImages.forEach((image) => {

        const speed = 0.08;

        image.style.transform =
          `translateY(${scrollTop * speed}px) scale(1.08)`;

      });

    });

  }

});